const standardDiscount = '15 %';

const unisportDiscount = '40 %';

export { standardDiscount, unisportDiscount };
